import { Injectable } from '@angular/core';
import * as Parse from 'parse';
import {PARSE_APP_ID, PARSE_MASTER_KEY, PARSE_SERVER_URL, production} from "../util/constants";


@Injectable()
export class SistemasService {

  parseAppId = PARSE_APP_ID;
  serverURL = PARSE_SERVER_URL;
  masterKey = PARSE_MASTER_KEY;

  constructor() { }

  init() {
    if (!production) {
      Parse.CoreManager.set('REQUEST_HEADERS', {'x-parse-application-id': this.parseAppId});
      Parse.CoreManager.set('REQUEST_HEADERS', {'x-parse-master-key': this.masterKey});
    }
    Parse.initialize(this.parseAppId, this.masterKey);
    Parse.serverURL = this.serverURL;
  }

  async get(objectId?: number) {
    this.init();
    const Servico = Parse.Object.extend('servico');
    const queryServico = new Parse.Query(Servico);
    queryServico.equalTo('ativo', true);
    queryServico.ascending('ordem');
    if (objectId) {
      queryServico.equalTo('objectId', objectId);
    }
    queryServico.include('modulos');
    const results = await queryServico.find();
    const arrayFinal: Array<any> = [];
    if (results.length > 0) {
      for (let i = 0; i < results.length; i ++) {
        const queryModulos = results[i].get('modulos').query();
        queryModulos.ascending('ordem');
        queryModulos.equalTo('ativo', true);
        const modulos = await queryModulos.find();
        let modo: Array<any> = JSON.parse(JSON.stringify(modulos));
        let arrayModulos = await this.submodules(modo, modulos);

        // tslint:disable-next-line:no-shadowed-variable

        const servico = JSON.parse(JSON.stringify(results[i]));
        servico.modulos = arrayModulos;
        if (arrayModulos.length > 0) {
          arrayFinal.push(servico);
        }
      }
    }
    return JSON.parse(JSON.stringify(arrayFinal));
  }

  async getBanners(objectId?: number) {
    this.init();
    const Servico = Parse.Object.extend('servico');
    const queryServico = new Parse.Query(Servico);
    queryServico.equalTo('ativo', true);
    queryServico.ascending('ordem');
    if (objectId) {
      queryServico.equalTo('objectId', objectId);
    }
    queryServico.include('modulos');
    const results = await queryServico.find();
    return JSON.parse(JSON.stringify(results));
  }

  async submodules(arrayModulos, modulos) {
    console.log('modulos=====', modulos)
    for (let i = 0; i < modulos.length; i ++) {
      const querySubModulo = modulos[i].get('subModulos').query();
      querySubModulo.ascending('ordem');
      const subModulos = await querySubModulo.find();
      const subModulosFinal = JSON.parse(JSON.stringify(subModulos));
      // tslint:disable-next-line:no-shadowed-variable
      for (let i = 0; i < subModulos.length; i++) {
        const queryDownloads = subModulos[i].get('downloads').query().ascending(subModulos[i].id == 'h2WChWqpRM'?"updatedAt":"createdAt");
        const downloads = await queryDownloads.find();
        subModulosFinal[i].downloads = JSON.parse(JSON.stringify(downloads));
      }
      arrayModulos[i].subModulos = subModulosFinal;
    }
    return arrayModulos;
  }

  async getForm(id) {
    this.init();
    const Classe = Parse.Object.extend('formularioApp');
    const query = new Parse.Query(Classe);
    query.equalTo("app", id);
    let objSetor = await query.find();
    return JSON.parse(JSON.stringify(objSetor));
  }

  async getApp(SG) {
    this.init();
    const Classe = Parse.Object.extend('formularioApp');
    const query = new Parse.Query(Classe);
    //query.equalTo("app", id);
    let objSetor = await query.find();
    return JSON.parse(JSON.stringify(objSetor));
  }

  async getFormSub(id) {
    this.init();
    const Classe = Parse.Object.extend('subform');
    const query = new Parse.Query(Classe);
    query.equalTo("app", id);
    let objSetor = await query.find();
    return JSON.parse(JSON.stringify(objSetor));
  }

  async getTerm (id) {
    this.init();
    const Classe = Parse.Object.extend('termoApp');
    const query = new Parse.Query(Classe);
    query.equalTo("app", id);
    let objSetor = await query.find();
    let term = JSON.parse(JSON.stringify(objSetor));
    console.log('term----', term)
    return (term.length > 0) ? term[0].termo: "";
  }

  async getPortifolioById (id) {
    this.init();
    const Classe = Parse.Object.extend('servico');
    const query = new Parse.Query(Classe);
    query.equalTo("portifolio", id);
    let objSetor = await query.find();
    let portifolio = JSON.parse(JSON.stringify(objSetor));
    console.log('portifolio----', portifolio);
    return (portifolio.length > 0) ? portifolio[0] : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sistemas.service.ts